import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DetailEditorPropsByYear } from '../types'
import { BiomassBurningInputEditorSimple } from './BiomassBurningInputEditorSimple'

export const BiomassBurningInputEditor = ({
  name = 'biomassBurning',
  year,
}: Pick<DetailEditorPropsByYear, 'name' | 'year'>) => {
  const { t } = useTranslation('@cibo/landmanager/BiomassBurningEditor')

  return (
    <Stack spacing={2}>
      <Typography>{t('cta', { year })}</Typography>

      <BiomassBurningInputEditorSimple name={name} />
    </Stack>
  )
}
